'use client'

import { useState, useEffect } from 'react'
import Header from "./components/ui/Header"
import Footer from "./components/ui/Footer"
import { Container } from "./components/ui/Container"
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./components/ui/Tabs"
import yaml from 'js-yaml'

function KVTable({ items, setItems, placeholderKey, placeholderValue }) {
    useEffect(() => {
        if (items.length === 0) setItems([{ key: '', value: '' }])
    }, [items, setItems])

    const update = (i, field, value) => {
        const next = [...items]
        next[i][field] = value
        setItems(next)
    }
    const add = () => setItems([...items, { key: '', value: '' }])
    const remove = (i) => setItems(items.filter((_, idx) => idx !== i))

    return (
        <div class="input-container">
            <div class="input-body">
                {items.map((kv, i) => (
                    <div class="input-wrapper" key={i}>
                        <input class="input-small" type="text" name="key" value={kv.key} placeholder={placeholderKey} onChange={e => update(i, 'key', e.target.value)}/>
                        <input type="text" name="value" value={kv.value} placeholder={placeholderValue} onChange={e => update(i, 'value', e.target.value)}/>
                        <button class="btn btn-red" onClick={() => remove(i)}>移除</button>
                    </div>
                ))}
            </div>
            <div class="input-foot">
                <button class="btn btn-green" onClick={add}>+ 添加参数</button>
            </div>
        </div>
    )
}

export default function ApiClientUI() {
    const [docInfo, setDocInfo] = useState({description:'', url:''})
    const [title, setTitle] = useState('')
    const [product, setProduct] = useState(0)
    const [instance, setInstance] = useState(0)
    const [productUrl, setProductUrl] = useState('')
    const [method, setMethod] = useState('GET')
    const [url, setUrl] = useState('')
    const [bodyType, setBodyType] = useState('json')
    const [body, setBody] = useState('')
    const [formBody, setFormBody] = useState([{ key: '', value: '' }])
    const [response, setResponse] = useState('')
    const [responseJSON, setResponseJSON] = useState(null)
    const [iframeUrl, setIframeUrl] = useState(null)
    const [responseTab, setResponseTab] = useState('body')
    const [responseHeaders, setResponseHeaders] = useState({})

    const isContentTypeJson = ((responseHeaders['content-type'] || responseHeaders['Content-Type'] || '')).includes('application/json')

    const [headers, setHeaders] = useState([{ key: '', value: '' }])
    const [params, setParams] = useState([{ key: '', value: '' }])

    // OpenAPI / left-side interface selection
    const [spec, setSpec] = useState(null)
    const [pathList, setPathList] = useState([])
    const [selectedPath, setSelectedPath] = useState(null)
    const [selectedMethod, setSelectedMethod] = useState(null)
    const [specUrl, setSpecUrl] = useState('')

    const [authEnabled, setAuthEnabled] = useState(false)
    const [token, setToken] = useState('')

    const loadSpec = async (specUrlToLoad) => {
        try {
            const res = await fetch(specUrlToLoad, {
                credentials: 'include',
            })
            const contentType = res.headers.get('content-type') || ''
            let loaded
            if (contentType.includes('application/json')) {
                loaded = await res.json()
            } else {
                const text = await res.text()
                try { loaded = yaml.load(text) } catch { loaded = null }
            }

            if (!loaded) return
            console.log('OpenAPI spec', loaded)
            if(loaded.externalDocs){
                setDocInfo({description:loaded.externalDocs.description, url:loaded.externalDocs.url})
            }else{
                setDocInfo({description:'', url:''})
            }
            setTitle(loaded.info.title||'')
            setProduct(loaded.info.product||0)
            setInstance(loaded.info.instance||0)
            setProductUrl(loaded.info.url||'')
            setSpec(loaded)
            const paths = Object.keys(loaded.paths || {})
            setPathList(paths)

            // auto-select first path+method
            if (paths.length) {
                const p = paths[0]
                const methods = Object.keys(loaded.paths[p] || {})
                if (methods.length) applyOperation(p, methods[0], specUrlToLoad, loaded)
            }
        } catch (err) {
            console.error('Failed to load OpenAPI spec', err)
        }
    }

    const applyOperation = (p, m, specUrlLocal, specObj) => {
        const s = specObj || spec
        if (!s) return
        const pathObj = s.paths[p]
        if (!pathObj) return
        const operation = pathObj[m]
        if (!operation) return

        const base = (s.servers && s.servers[0] && s.servers[0].url) || (specUrlLocal ? (new URL(specUrlLocal).origin) : window.location.origin)
        let finalUrl = base.replace(/\/$/, '') + p
        finalUrl = finalUrl.replace(/\{[^}]+\}/g, '1')

        setSelectedPath(p)
        setSelectedMethod(m)
        setMethod(m.toUpperCase())
        setUrl(finalUrl)

        const paramsArr = operation.parameters || []
        const queryParams = paramsArr.filter(p => p.in === 'query').map(p => ({ key: p.name, value: p.example || '' }))
        setParams(queryParams)
        const headerParams = paramsArr.filter(p => p.in === 'header').map(p => ({ key: p.name, value: p.example || '' }))
        if(operation.responses && operation.responses['200'] && operation.responses['200'].content && operation.responses['200'].content['text/html']){
            headerParams.push({ key: 'Accept', value: 'text/html' })
        }
        setHeaders(headerParams)
        const postParams = paramsArr.filter(p => p.in === 'post').map(p => ({ key: p.name, value: p.example || '' }))
        setFormBody(postParams)
        

        const requestBody = operation.requestBody
        if (requestBody && requestBody.content) {
            const content = requestBody.content['application/json'] || requestBody.content[Object.keys(requestBody.content)[0]]
            if (content) {
                let example = content.example
                if (!example && content.examples) {
                    const key = Object.keys(content.examples)[0]
                    example = content.examples[key] && content.examples[key].value
                }
                if (!example && content.schema) {
                    example = generateExampleFromSchema(content.schema)
                }
                if (example) {
                    setBodyType('json')
                    setBody(JSON.stringify(example, null, 2))
                    setHeaders(prev => {
                        const next = [...prev]
                        const idx = next.findIndex(h => h.key.toLowerCase() === 'content-type')
                        if (idx === -1) next.push({ key: 'Content-Type', value: 'application/json' })
                        else next[idx].value = 'application/json'
                        return next
                    })
                }
            }
        }

        const responseContent = operation.responses && operation.responses['200'] && operation.responses['200'].content
        if (responseContent) {
            const resp = responseContent['application/json'] || responseContent[Object.keys(responseContent)[0]]
            if (resp && resp.examples) {
                const key = Object.keys(resp.examples)[0]
                const example = resp.examples[key] && resp.examples[key].value
                if (example) {
                    setResponseJSON(example)
                    setResponseTab('json')
                }
            }
        }
    }

    useEffect(() => {
        const tryApplyFromHash = () => {
            const hash = window.location.hash.replace(/^#/, '')
            const params = new URLSearchParams(hash)
            let openapiUrl = params.get('openapi')
            const marketId = params.get('market')
            if(marketId){
                openapiUrl = 'https://api.cn/market/'+marketId+'.json'
            }
            if (openapiUrl){
                console.log('Applying openapi from hash', openapiUrl);
                setSpecUrl(openapiUrl)
                loadSpec(openapiUrl)
            }
        }
        window.addEventListener('hashchange', tryApplyFromHash)
        tryApplyFromHash()
        return () => window.removeEventListener('hashchange', tryApplyFromHash)
    }, []);

    const buildUrl = () => {
        const u = new URL(url)
        params.forEach(p => {
            if (p.key) u.searchParams.set(p.key, p.value)
        })
        return u.toString()
    }

    const buildHeaders = () => {
        const h = {}
        headers.forEach(kv => {
            if (kv.key) h[kv.key] = kv.value
        })
        if (authEnabled && token) {
            h['Authorization'] = `Bearer ${token}`
        }
        if (!h['Content-Type']) {
            if (bodyType === 'json' && body) h['Content-Type'] = 'application/json'
            if (bodyType === 'form') h['Content-Type'] = 'application/x-www-form-urlencoded'
            if (bodyType === 'text') h['Content-Type'] = 'text/plain'
        }
        return h
    }

    const send = async () => {
        try {
            setResponseTab('body')
            setIframeUrl(null)
            setResponse('Loading...')
            setResponseJSON(null)
            setResponseHeaders({})

            let requestBody
            if (!['GET', 'HEAD'].includes(method)) {
                if (bodyType === 'json' || bodyType === 'text') requestBody = body
                if (bodyType === 'form') {
                    const params = new URLSearchParams()
                    formBody.forEach(kv => {
                        if (kv.key) params.append(kv.key, kv.value)
                    })
                    requestBody = params.toString()
                }
            }

            if(headers.find(h => h.key === 'Accept' && h.value === 'text/html')){
                setResponse('Load page')
                setIframeUrl(buildUrl())
                setResponseTab('iframe')
                return
            }
            if(url.includes('.html') && method === 'GET'){
                setResponse('Load page')
                setIframeUrl(buildUrl())
                setResponseTab('iframe')
                return
            }

            const res = await fetch(buildUrl(), {
                method,
                headers: buildHeaders(),
                body: requestBody
            })

            const text = await res.text()
            const hdrs = {}
            res.headers.forEach((v, k) => (hdrs[k] = v))
            setResponseHeaders(hdrs)
            setResponse(`Status: ${res.status}\n\n${text}`)
            
            try {
                setResponseJSON(JSON.parse(text))
                setResponseTab('json')
                if(!isContentTypeJson){
                    hdrs['content-type'] = 'application/json; add-from=text parse'
                    setResponseHeaders(hdrs)
                }
            } catch {
                setResponseJSON(null)
            }
        } catch (e) {
            setResponse(String(e))
            setResponseJSON(null)
        }
    }

    return (
        <div class="wrapper">
            <Header />
            <Container>
                <div class="layout-container">
                    <aside>
                        <div class="module mod-menu">
                            <div class="bd">
                                <div class="doc-container">
                                    <div class="c-hd"><span>OpenAPI规范</span></div>
                                    <div class="c-bd">
                                        <div class="input-wrapper">
                                            <input name="doc" value={specUrl} onChange={e => setSpecUrl(e.target.value)} placeholder="OpenAPI URL"/>
                                            <button class="btn btn-blue" onClick={() => loadSpec(specUrl)}>加载</button>
                                        </div>
                                    </div>
                                    {docInfo.url && (
                                        <div class="c-ft">
                                            <a href={docInfo.url} target="_blank">
                                                {docInfo.description || docInfo.url}
                                            </a>
                                        </div>
                                    )}
                                </div>
                                <div class="list-container">
                                    <div class="c-hd"><span>API列表</span></div>
                                    <div class="c-bd">
                                        <div class="list">
                                            {pathList.length ? pathList.map(p => (
                                                <div key={p} class={`item${selectedPath === p ? ' active' : ''}`} tabIndex={0}
                                                    onClick={() => { const methods = Object.keys(spec.paths[p] || {}); if (methods.length) applyOperation(p, methods[0]); }}
                                                    onKeyDown={(e) => { if (e.key === 'Enter') { const methods = Object.keys(spec.paths[p] || {}); if (methods.length) applyOperation(p, methods[0]); } }}
                                                >
                                                    {spec && spec.paths && spec.paths[p] && spec.paths[p][Object.keys(spec.paths[p])[0]] && (
                                                        <div class="title">{spec.paths[p][Object.keys(spec.paths[p])[0]].summary}</div>
                                                    )}
                                                    <div class="api-container">
                                                        {Object.keys((spec && spec.paths && spec.paths[p]) || {}).map(m => (
                                                            <button class="btn btn-small btn-green" key={m} onClick={(e) => { e.stopPropagation(); applyOperation(p, m) }}>
                                                                {m.toUpperCase()}
                                                            </button>
                                                        ))}
                                                        <span class="text">{p}</span>
                                                    </div>
                                                </div>
                                            )) : (
                                                <div class="none">未加载规范</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </aside>
                    <main>
                        <div class="module mod-panel">
                            {title && (
                                <div class="hd">
                                    <h1>
                                        <a href={productUrl} target="_blank" rel="noreferrer">
                                            {title || "产品介绍"}
                                        </a>
                                    </h1>
                                    <a class="btn btn-green" href={productUrl} target="_blank">购买</a>
                                </div>
                            )}
                            <div class="bd">
                                <h3><span>接口调试</span></h3>
                                <p class="text-gray">本页面用于发起接口调试，调用接口会消耗真实费用，测试不能替代实际环境。</p>
                                <div class="request-container">
                                    <div class="input-wrapper">
                                        <select name="method" value={method} onChange={e => setMethod(e.target.value)}>
                                            {['GET', 'POST', 'PUT', 'DELETE', 'PATCH'].map(m => (
                                                <option key={m}>{m}</option>
                                            ))}
                                        </select>
                                        <input name="url" value={url} onChange={e => setUrl(e.target.value)} placeholder="请求网址"/>
                                        <button class="btn btn-blue" onClick={send}>发送</button>
                                    </div>
                                </div>

                                <Tabs defaultValue="headers">
                                    <TabsList>
                                        <TabsTrigger value="headers">Headers</TabsTrigger>
                                        <TabsTrigger value="params">Params</TabsTrigger>
                                        <TabsTrigger value="auth">Auth</TabsTrigger>
                                        <TabsTrigger value="body">Body</TabsTrigger>
                                    </TabsList>

                                    <TabsContent value="headers">
                                        <KVTable items={headers} setItems={setHeaders} placeholderKey="Header参数名" placeholderValue="Header参数值" />
                                    </TabsContent>

                                    <TabsContent value="params">
                                        <KVTable items={params} setItems={setParams} placeholderKey="Param参数名" placeholderValue="Param参数值" />
                                    </TabsContent>

                                    <TabsContent value="auth">
                                        <div class="input-wrapper">
                                            <label>
                                                <input type="checkbox" checked={authEnabled} onChange={e => setAuthEnabled(e.target.checked)} />
                                                <span>Bearer Token</span>
                                            </label>
                                            {authEnabled && (
                                                <input placeholder="Bearer token" value={token} onChange={e => setToken(e.target.value)} />
                                            )}
                                        </div>
                                    </TabsContent>

                                    <TabsContent value="body">
                                        <div class="input-wrapper">
                                            <select value={bodyType} onChange={e => setBodyType(e.target.value)}>
                                                <option value="json">JSON</option>
                                                <option value="form">x-www-form-urlencoded</option>
                                                <option value="text">Raw Text</option>
                                            </select>
                                        </div>
                                        {bodyType === 'json' && <div class="input-wrapper"><textarea placeholder="JSON body" value={body} onChange={e => setBody(e.target.value)} /></div>}
                                        {bodyType === 'text' && <div class="input-wrapper"><textarea placeholder="Raw text body" value={body} onChange={e => setBody(e.target.value)} /></div>}
                                        {bodyType === 'form' && <KVTable items={formBody} setItems={setFormBody} placeholderKey="Field" placeholderValue="Value" />}
                                    </TabsContent>
                                </Tabs>
                                
                                <h3><span>响应数据</span></h3>
                                <Tabs defaultValue="headers">
                                    <TabsList>
                                        <TabsTrigger value="headers">Headers</TabsTrigger>
                                    </TabsList>
                                    <TabsContent value="headers">
                                        <pre>
                                            {Object.keys(responseHeaders).length ? JSON.stringify(responseHeaders, null, 2) : '无响应数据'}
                                        </pre>
                                    </TabsContent>
                                </Tabs>

                                <Tabs value={responseTab} onValueChange={setResponseTab}>
                                    <TabsList>
                                        <TabsTrigger value="body">Body</TabsTrigger>
                                        {isContentTypeJson && (
                                            <TabsTrigger value="json" disabled={!responseJSON}>JSON</TabsTrigger>
                                        )}
                                        {iframeUrl && (
                                            <TabsTrigger value="iframe" disabled={!iframeUrl}>Page</TabsTrigger>
                                        )}
                                    </TabsList>

                                    <TabsContent value="body">
                                        <pre>
                                            {response || '无响应数据'}
                                        </pre>
                                    </TabsContent>

                                    {isContentTypeJson && (
                                        <TabsContent value="json">
                                            {responseJSON ? (
                                                <pre>
                                                    {JSON.stringify(responseJSON, null, 2)}
                                                </pre>
                                            ) : (
                                                <pre>响应数据为无效JSON格式</pre>
                                            )}
                                        </TabsContent>
                                    )}
                                    {iframeUrl && (
                                        <TabsContent value="iframe">
                                            {iframeUrl ? (
                                                <iframe src={`${iframeUrl}`}/>
                                            ) : (
                                                <pre>响应数据为无效页面</pre>
                                            )}
                                        </TabsContent>
                                    )}
                                </Tabs>
                            </div>
                        </div>
                    </main>
                </div>
            </Container>
            <Footer />
        </div>
    )
}
